import { apiClient } from '@common/api'

/**
 * userReport API service
 * Converted from AngularJS: api.userReport.js
 */
export const userReportApi = {
  getAll: () =>
    apiClient.get('/userreport/'),

  post: (id: any) =>
    apiClient.post('/userreport', {id: id}),
}
